import React, { FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { useIntl } from 'react-intl'
import { SocialLink } from '..'
import { Button } from '../../../atoms/button'
import { convertToRem } from '../../../../utils/style'

interface SocialLinksProps {
  links: SocialLink[]
  className?: string
}

const getSocialNetworkName = (url: string): string => {
  try {
    const hostname = new URL(url).hostname.toLowerCase()
    if (hostname.includes('linkedin')) return 'LinkedIn'
    if (hostname.includes('instagram')) return 'Instagram'
    if (hostname.includes('facebook')) return 'Facebook'
    if (hostname.includes('youtube')) return 'YouTube'
    if (hostname.includes('twitter') || hostname.includes('x.com')) return 'X'
    return hostname.replace(/^www\./, '')
  } catch {
    return url
  }
}

const SocialLinks: FunctionComponent<SocialLinksProps> = ({ links, className }) => {
  const intl = useIntl()

  return (
    <SocialLinksWrapper className={className}>
      {links.map((link, index) => {
        const networkName = getSocialNetworkName(link.link)
        return (
          <li key={`social-link-${link.icon}-${index}`}>
            <Link
              themeOverride="background_is_lighter_secondary"
              variant="outlined"
              as="a"
              href={link.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={intl.formatMessage(
                { id: 'footer.social_network_link' },
                { network: networkName },
              )}
            >
              <img src={link.icon.url} alt="" />
            </Link>
          </li>
        )
      })}
    </SocialLinksWrapper>
  )
}

const SocialLinksWrapper = styled.ul`
  display: flex;
  list-style: none;
  gap: var(--gap-m);
  img {
    height: 1.25rem;
  }

  @media (max-width: 1279px) {
    justify-content: space-between;
  }
`
const Link = styled(Button)`
  padding: ${convertToRem(20)};
  width: ${convertToRem(62)} !important;
`

export default SocialLinks
export { Link as SocialLink }
